document.addEventListener('DOMContentLoaded', function() {
    var menuToggle = document.getElementById('menu-toggle');
    var fullscreenMenu = document.getElementById('fullscreen-menu');
    var masthead = document.getElementById('masthead');
    var body = document.body; // Reference to the body element
    
    menuToggle.addEventListener('click', function() {
        // Check if the fullscreen menu is currently hidden
        if (fullscreenMenu.classList.contains('hidden')) {
            // Remove the 'hidden' class and add 'flex'
            fullscreenMenu.classList.remove('hidden');
            fullscreenMenu.classList.add('flex');
            masthead.classList.add('navigation-open');
        } else {
            // If the menu is shown, we revert back to the original state
            fullscreenMenu.classList.add('hidden');
            fullscreenMenu.classList.remove('flex');
            masthead.classList.remove('navigation-open');
        }
        // Toggle overflow on the body
        body.classList.toggle('overflow-hidden');
        body.classList.toggle('navigation-open');
        // Toggle the hamburger animation
        menuToggle.classList.toggle('is-active');
        
        // Now handle the fade-in animations for each menu item if the menu is shown
        const menuItems = document.querySelectorAll('#fullscreen-menu .menu-item');
        if (!fullscreenMenu.classList.contains('hidden')) {
            menuItems.forEach((item, index) => {
                // Remove all existing fade-in classes
                item.classList.remove('fade-in', 'fade-in-1', 'fade-in-2', 'fade-in-3', 'fade-in-4');
                // Add the fade-in class for animation properties
                item.classList.add('fade-in');
                // Add the specific fade-in class based on index for delay
                item.classList.add(`fade-in-${index+1}`);
            });
        } else {
            // If the menu is hidden, reset the animation classes so they can be re-applied next time
            menuItems.forEach((item) => {
                item.classList.remove('fade-in', 'fade-in-1', 'fade-in-2', 'fade-in-3', 'fade-in-4');
            });
        }
    });
});